import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Button, Carousel, CarouselItem, Input, Empty } from "element-ui";
import "lib-flexible";
import beian from "./components/gongan.vue";
Vue.component("BeiAn", beian);
Vue.config.productionTip = false;
Vue.use(Button);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Input);
Vue.use(Empty);
import Router from "vue-router";

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this; //安装全局事件总线，$bus就是当前应用的vm
  },
}).$mount("#app");
